import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { App } from 'pages/App';
import Routes from 'pages/Routes';
import { QueryClient, QueryClientProvider } from 'react-query';
import * as axiosClient from 'utils/api/axiosClient';
import { configureStore } from './store';
import {
  ErrorProvider,
  ErrorContext,
} from 'components/Patient/context/ErrorContext';

import {
  API_URL,
  API_URL_FOR_LISTS,
  SENTRY_DSN,
  BUILD_NUMBER,
  SENTRY_ENV,
  SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_REPLAYS_ON_ERROR_RATE,
} from 'config/constants';

import './styles/index.scss';
import { Toaster } from 'components/Toaster';

try {
  if (!!SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: BUILD_NUMBER,
      environment: SENTRY_ENV,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: SENTRY_REPLAYS_ON_ERROR_RATE,
      tracePropagationTargets: [API_URL, API_URL_FOR_LISTS],
    });
  }
} catch (e) {
  console.error('Unable to initialize Sentry');
  console.error(e);
}

export const MOUNT_NODE = document.getElementById('root');

const initialState = {};
const store = configureStore(initialState);
const queryClient = new QueryClient();

ReactDOM.render(
  <>
    <Toaster />

    <Provider store={store}>
      <ErrorProvider>
        <ErrorContext.Consumer>
          {({ setErrorMessageAlert }) => {
            axiosClient.init({
              store,
              API_URL,
              API_URL_FOR_LISTS,
              setErrorMessageAlert,
            });

            return (
              <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                  <Helmet defaultTitle="Anova">
                    <meta
                      name="description"
                      content="Anova OneSource web application."
                    />
                  </Helmet>
                  <ErrorBoundary>
                    <App>
                      <Routes />
                    </App>
                  </ErrorBoundary>
                </BrowserRouter>
              </QueryClientProvider>
            );
          }}
        </ErrorContext.Consumer>
      </ErrorProvider>
    </Provider>
  </>,
  MOUNT_NODE,
);
